import React from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';

const PaymentButton = ({ urlPagoPropiaCliente }) => {
  return (
    <div className='p-6 bg-white'>
      <div className='text-center'>
        <a
          href={urlPagoPropiaCliente}
          target='_blank'
          rel='noopener noreferrer'
          className='inline-flex items-center px-8 py-4 text-base font-semibold rounded-lg text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-150 shadow-sm'
        >
          <LockClosedIcon className='w-5 h-5 mr-2' />
          Realizar pago seguro
        </a>
        <p className='mt-4 text-sm text-slate-500'>Serás redirigido a nuestra plataforma segura de pago</p>
      </div>
    </div>
  );
};

export default PaymentButton;
